import { Outlet, Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { clientAuthenticatedOptions } from "../../services/client/@tanstack/react-query.gen";
import { Spin } from "antd";
import { client } from "../../services/client/client.gen";
import { client as licensingClient } from "../../services/licensing/client/client.gen";
import { AuthenticatedUser, decodeToken } from "./AuthContext";

export const AuthenticationGuard = () => {
  const token = localStorage.getItem("token");

  const { data, isPending, error } = useQuery({
    ...clientAuthenticatedOptions({
      headers: { Authorization: `Bearer ${token}` },
    }),
    retry: false,
  });

  if (isPending && !error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin />
      </div>
    );
  }

  if (error || !data) {
    return <Navigate to="/login" />;
  }

  client.setConfig({
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  licensingClient.setConfig({
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const decoded = decodeToken(token!);

  return (
    <AuthenticatedUser.Provider value={decoded}>
      <Outlet />
    </AuthenticatedUser.Provider>
  );
};
